<template>
        <dt>
            <label  v-if="userProfile">Submitted By</label>
            <label  v-else>Email</label> 
                <!-- <div  v-for="(vr) in validationResults">
                    <span v-if="!vr.valid" class="text-danger" >{{vr.message}}</span>
                    <span v-else-if="vr.valid" class="text-success" >{{vr.message}}</span>
                </div> -->
            <validation-results :validationResults="validationResults" />
        </dt>
        <dd>
            <div v-if="userProfile" class="d-flex ">
                <profile-picture class="profile-picture-sm" :profileInfo="userProfile.profileInfo" />
                <span>{{ userProfile.displayName }}</span>
            </div>
            <input v-else type="text" class="form-control" v-model="proxyValue" :disabled="disabled" />
        </dd>
 
</template>
 
  
<script lang="ts">
import { Inject, Options, Prop, Vue, Watch } from 'vue-property-decorator';  
import {FormLayout, FormField, setProxyValue, FieldValidationResult} from './Forms';
import { UserProfile } from '@/data/repository/UserInfo';
import ProfilePicture from '../shell/ProfilePicture.vue';
import ValidationResults from './ValidationResults.vue'

@Options({components:{ProfilePicture, ValidationResults}})
export default class EmailField extends Vue
{
   @Prop() public userProfile!: UserProfile;
   @Prop() public field!: FormField;
   @Prop() public data!: any;
   @Prop() public validationResults!: FieldValidationResult[];
   @Prop({default:false}) public disabled!: boolean;

   public proxyValue="";

   @Watch("proxyValue")
   public proxyValueChanged()
   {
     this.data[this.field.name] = this.proxyValue;
   }

   public mounted()
   {
     setProxyValue(this);
   }
}

</script>